<link *ngFor="let layoutFile of layoutFiles; let i = index" rel="preload" as="style" [href]="layoutFile.safeUrl"
  (load)="customCssLoaded(i)" (error)="customCssErrored(i)">
<link *ngFor="let activeLayoutFile of activeLayoutFiles" rel="stylesheet" [href]="activeLayoutFile.safeUrl">
<div class="atire" *ngIf="!isOnline">
  <div class="wrapper">
    <img class="logoImg mb-3" alt="School Logo" [src]="logoUrl" *ngIf="logoUrl" />
    <h1>OFFLINE</h1>
    <h4>Please check your internet connection</h4>
  </div>
</div>
<div class="atire" *ngIf="!isSchoolEnabled && !isNotFoundError">
  <div class="wrapper">
    <img class="logoImg mb-3" alt="School Logo" [src]="logoUrl" *ngIf="logoUrl" />
    <h1>SCHOOL DISABLED</h1>
  </div>
</div>
<div class="atire" *ngIf="isNotFoundError">
  <div class="wrapper">
    <img class="logoImg mb-3" alt="School Logo" [src]="logoUrl" *ngIf="logoUrl" />
    <h1>SCHOOL NOT FOUND</h1>
  </div>
</div>
  <router-outlet *ngIf="isOnline && isSchoolEnabled"></router-outlet>
<div class="modal fade" id="appComponentConfirmModal" tabindex="-1" role="dialog" aria-hidden="true"
  data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="appComponentConfirmModal_Title"></h3>
        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button> -->
      </div>
      <div class="modal-body" id="appComponentConfirmModal_Body">

      </div>
      <div class="modal-footer justify-content-center gap-1.5">
        <button type="button" class="btn m-0" data-dismiss="modal"
          (click)="this.utilservice.confirmYesClicked()">{{this.utilservice.dialogConfirmMode ? "Yes" : "Ok"}}</button>
        <button *ngIf="this.utilservice.dialogConfirmMode" type="button" class="btn btn--warning m-0"
          data-dismiss="modal" (click)="this.utilservice.confirmNoClicked()">No</button>
      </div>
    </div>
  </div>
</div>
